import api from './api';

// The scheduling assistant. The model only ever proposes catalogued procedure
// calls; reads run straight away, writes come back as a proposal that runs
// only when confirmed.
const assistantService = {
  status: () => api.get('/assistant/status').then((r) => r.data),
  // payload: { text, channel: 'voice'|'text', client_now: { date, time }, history: [{ text, plan }] }
  interpret: (payload) => api.post('/assistant/interpret', payload).then((r) => r.data),
  confirm: (proposalId) => api.post('/assistant/confirm', { proposal_id: proposalId }).then((r) => r.data),
  cancel: (proposalId) => api.post('/assistant/cancel', { proposal_id: proposalId }).then((r) => r.data),

  // Admin
  catalogue: () => api.get('/assistant/catalogue').then((r) => r.data.procedures || []),
  updateProcedure: (code, patch) => api.put(`/assistant/catalogue/${encodeURIComponent(code)}`, patch).then((r) => r.data.procedure),
  log: () => api.get('/assistant/log').then((r) => r.data.entries || []),
};

export default assistantService;
